import { DROP_FILTER_OPEN } from '../action-types';

const initialState = {
    open: false, type: ''
};

export default function(state = initialState, action) {
    switch (action.type) {
        case DROP_FILTER_OPEN: {
          return action.payload;
        }
        default: {
          return state;
        }
    }
}
